(() => {
  document.addEventListener("BSS:changevariant", e => {
    setTimeout(() => {
      const productForm = document.querySelector("[bss-b2b-main-product-form]");
      BSS_B2B?.observer?.productSubject?.notifyObserver?.('VariantChange', 'VariantSelectChange', {productForm});
    }, 500)
  })

  const maxWaitTime = 8000; 
  const intervalTime = 100;
  let elapsed = 0;
  
  const intervalId = setInterval(() => {
    const btnWrapper = document.querySelector(".btn-wrapper-default");
    const taxWrapper = document.querySelector(".bss-b2b-tax-ex-wrapper");
  
    if (btnWrapper && taxWrapper) {
      btnWrapper.parentNode.insertBefore(taxWrapper, btnWrapper);
      clearInterval(intervalId);
    }
  
    elapsed += intervalTime;
    if (elapsed >= maxWaitTime) {
      clearInterval(intervalId);
    }
  }, intervalTime);
})()